import { advancedFlowSchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { FulfillmentGroupAutomationRunSchema } from "@redotech/redo-flows-common/oms/fulfillment-group-automation-run";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getFulfillmentGroupAutomationRuns = {
  name: "getFulfillmentGroupAutomationRuns" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({
    runs: z.array(FulfillmentGroupAutomationRunSchema),
    flows: z.array(advancedFlowSchema),
  }),
};
